<div class="row" style="background: #fff;border-radius: 7px;">
    <div class="align-items-center d-flex h-100 justify-content-center row w-100">
        <img src="/assets/images/modules/under_maintenance.jpg" class="img-fluid" alt="Under maintenance"
            style="width: 28rem; height: 28rem;">
    </div>

    <div class="p-1 py-4 text-captialize d-flex justify-content-center align-items-center">
        <button mat-raised-button color="primary"  class="homepage_btn" (click)="goBack()"
            [innerHtml]="staticText?.error_pages?.page_not_found?.page_not_found_route_button">
        </button>
    </div>
    
</div>